<template>
  <div>
    <div class="pdf">
      <div class="tools">
        <el-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="prePage"
          :disabled="flag1"
          class="mr10"
        > 上一页</el-button>
        <span class="page">{{pageNum}}/{{pageTotalNum}} </span>
        <el-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="nextPage"
          :disabled="flag2"
          class="mr10"
        > 下一页</el-button>
        <el-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="clock"
          class="mr10"
        > 顺时针</el-button>
        <el-button
          :theme="'default'"
          type="submit"
          :title="'基础按钮'"
          @click.stop="counterClock"
          class="mr10"
        > 逆时针</el-button>

      </div>
      <pdf
        ref="pdf"
        :src="url"
        :page="pageNum"
        :rotate="pageRotate"
        @progress="loadedRatio = $event"
        @page-loaded="pageLoaded($event)"
        @num-pages="pageTotalNum=$event"
        @error="pdfError($event)"
        @link-clicked="page = $event"
      >
      </pdf>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  props: {
    url: String,
  },
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      pageRotate: 0,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0,
      flag1:true,
      flag2:false
    };
  },
  mounted: function () {},
  methods: {
    // 上一页函数，
    prePage() {
      var page = this.pageNum;
      this.flag2=false
      if(page<=2){
        this.flag1=true
      }else{
        this.flag1=false
      }
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    // 下一页函数
    nextPage() {
      this.flag1=false
      var page = this.pageNum;
       if(page>=4){
        this.flag2=true
      }else{
        this.flag2=false
      }
      
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    // 页面顺时针翻转90度。
    clock() {
      this.pageRotate += 90;
    },
    // 页面逆时针翻转90度。
    counterClock() {
      this.pageRotate -= 90;
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.curPageNum = e;
    },
    // 其他的一些回调函数。
    pdfError(error) {
    },
    pdfPrintAll() {
      this.$refs.pdf.print();
    },
  },
};
</script>

<style scoped>
.pdf {
    width: 100%;
  position: relative;
}
.tools {
    padding: 5px;
  margin-bottom: 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  display: none;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  text-align: center;
}

.pdf:hover .tools {
  display: block;
}

.pdf /deep/ .el-button{
    background: transparent;
    color: #fff;
}

.page{
    color: #fff;
}
</style>